import { createSelector } from '@reduxjs/toolkit';
import { StoreType } from 'store';
import { LanguageTranslations, SupportedLanguages } from './types';

export const selectCurrentLanguage = createSelector(
  (state: StoreType) => state.localization.language,
  (language) => language,
);

export const selectProposedLanguage = createSelector(
  (state: StoreType) => state.localization.language,
  (state: StoreType) => state.localization.userLanguage,
  (state: StoreType) => state.localization.systemLanguage,
  (state: StoreType) => state.localization.fallbackLanguage,
  (state: StoreType) => state.localization.supportedLanguages,
  (
    currentLanguage: string,
    userLanguage: string | undefined,
    systemLanguage: string,
    fallbackLanguage: string,
    supportedLanguages: SupportedLanguages,
  ) => {
    let proposedLanguage = fallbackLanguage;
    if (userLanguage && supportedLanguages[userLanguage] != null) {
      proposedLanguage = userLanguage;
    } else if (supportedLanguages[systemLanguage] != null) {
      proposedLanguage = systemLanguage;
    }
    return currentLanguage !== proposedLanguage ? proposedLanguage : undefined;
  },
);

export const selectTranslationsInitialized = createSelector(
  (state: StoreType) => state.localization.translations,
  (translations: LanguageTranslations) => Object.keys(translations).length !== 0,
);

export const selectSupportedLanguages = createSelector(
  (state: StoreType) => state.localization.supportedLanguages,
  (supportedLanguages: SupportedLanguages) => supportedLanguages,
);

export const selectTranslation = createSelector(
  (state: StoreType) => state.localization.translations,
  (state: StoreType) => state.localization.language,
  (state: StoreType) => state.localization.fallbackLanguage,
  (translations: LanguageTranslations, language: string, fallbackLanguage: string) => {
    let languageTranslation = translations[language];
    if (languageTranslation == null) {
      languageTranslation = translations[fallbackLanguage];
    }
    return languageTranslation;
  },
);

export const selectFallbackTranslation = createSelector(
  (state: StoreType) => state.localization.translations,
  (state: StoreType) => state.localization.fallbackLanguage,
  (translations: LanguageTranslations, fallbackLanguage: string) => translations[fallbackLanguage],
);
